import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            用户真实反馈
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            来自数十万用户的真实声音，他们用 asmrone 改变了生活
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="p-6 md:p-8 rounded-lg bg-background-100/70 border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                &ldquo;{t.content}&rdquo;
              </p>

              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {t.name}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {t.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}